<div #container class="media-collection" >
  <canvas #canvas ></canvas>

  <span *ngIf="settingsService.settings.spell.wordActive" style="position: absolute; text-shadow:0px 0px 20px black; color: {{settingsService.settings.spell.wordColor}}; font-size: 36px; font-weight: bold">{{visualSpellConcept}}</span>
</div>


<!--overlay con la controladora de la galeria-->
<app-collection-controller [collection]="collection" (indexSelected)="collectionIndexOnChanged($event)" ></app-collection-controller>
